import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import getPersonName from "../../common/Name";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";
import getPhone from "../../common/Phone";
import { getDobDate, getMonthAndYear } from "../../common/DisplayDate";
import getSsn from "../../common/Ssn";

class Associates extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    const rows = [];
    let recCount = 0;
    const { isSilverReport } = this.props;
    const records = isSilverReport
      ? this.props.node
      : _.get(
          props.reportData,
          "personReport.compReportResponse[0].individual[0].associates[0].associate"
        );
    if (records !== undefined && records.length > 0) {
      _.forEach(records, (record, asstIndex) => {
        const asstRows = [];
        const header = isSilverReport
          ? `${_.get(record, "names[0].name[0].firstName[0]._", "")} ${_.get(
              record,
              "names[0].name[0].middleName[0]._",
              ""
            )} ${_.get(record, "names[0].name[0].lastName[0]._", "")}`
          : `${_.get(
              record,
              "AKAs[0].identity[0].name[0].first[0]._",
              ""
            )} ${_.get(
              record,
              "AKAs[0].identity[0].name[0].middle[0]._",
              ""
            )} ${_.get(record, "AKAs[0].identity[0].name[0].last[0]._", "")}`;
        const DOB = isSilverReport
          ? getMonthAndYear(_.get(record, "DOBs[0].DOB[0]"))
          : getDobDate(_.get(record, "AKAs[0].identity[0].DOB[0]"), {
              userAccount: this.props.userAccount,
            });

        const persAge = isSilverReport
          ? _.get(record, "DOBs[0].DOB[0].age[0]._", "")
          : _.get(record, "AKAs[0].identity[0].age[0]._", "");

        // asstRows.push(
        //   <Table.Row key={`associates_header_${asstIndex}`}>
        //     <Table.HeaderCell colSpan={3} className="report-sub-section-header">
        //       {header}{" "}
        //     </Table.HeaderCell>
        //   </Table.Row>
        // );
        if (_.get(record, "AKAs[0].identity[0].SSNInfo[0]") !== undefined) {
          asstRows.push(
            <Table.Row key={`ssn_info_${asstIndex}`}>
              <Table.Cell width={5}>
                <span className="text-bold"> SSN:</span>{" "}
                {getSsn(
                  _.get(record, "AKAs[0].identity[0].SSNInfo[0].SSN[0]._", ""),
                  props
                )}
              </Table.Cell>
              <Table.Cell width={7}>
                <span className="text-bold"> Issued:</span>{" "}
                {_.get(
                  record,
                  "AKAs[0].identity[0].SSNInfo[0].issuedStartDate[0].year[0]._",
                  ""
                )}
                {_.get(
                  record,
                  "AKAs[0].identity[0].SSNInfo[0].issuedLocation[0]._",
                  ""
                )}
              </Table.Cell>
              <Table.Cell width={4} />
            </Table.Row>
          );
        }
        asstRows.push(
          <Table.Row key={`associates_dob_${asstIndex}`}>
            <Table.Cell width={5}>
              <span className="text-bold">DOB: </span>
              {DOB}
            </Table.Cell>
            <Table.Cell width={7}>
              <span className="text-bold"> Age: </span>
              {persAge}
            </Table.Cell>
            <Table.Cell />
          </Table.Row>
        );

        const addressInfos = _.get(record, "addresses[0].address");
        if (isSilverReport) {
          const identities = _.get(record, "names[0].name");
          _.forEach(identities, (identity, index) => {
            if (index !== 0) {
              asstRows.push(
                <Table.Row key={`identity_row_${asstIndex}_${index}`}>
                  <Table.Cell width={10} colSpan={2}>
                    <span className="text-bold">AKA: </span>{" "}
                    {getPersonName(
                      _.get(identity, "firstName[0]._", ""),
                      _.get(identity, "middleName[0]._", ""),
                      _.get(identity, "lastName[0]._", ""),
                      props
                    )}
                  </Table.Cell>
                  <Table.Cell />
                </Table.Row>
              );
            }
          });

          _.forEach(addressInfos, (addressdetails, addIndex) => {
            asstRows.push(
              <Table.Row
                key={`address_row_${asstIndex}_${addIndex}`}
                className={addIndex % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3} className="text-bold">
                  Address:
                </Table.Cell>
                <Table.Cell width={13}>
                  <Address
                    addressNode={addressdetails}
                    noBreakIconsAndText
                    {...this.props}
                  />
                </Table.Cell>
              </Table.Row>
            );
          });
        } else {
          const identities = _.get(record, "AKAs[0].identity");
          _.forEach(identities, (identity, index) => {
            asstRows.push(
              <Table.Row key={`identity_row_${asstIndex}_${index}`}>
                <Table.Cell width={10} colSpan={2}>
                  <span className="text-bold">AKA: </span>{" "}
                  {getPersonName(
                    _.get(identity, "name[0].first[0]._", ""),
                    _.get(identity, "name[0].middle[0]._", ""),
                    _.get(identity, "name[0].last[0]._", ""),
                    props
                  )}
                </Table.Cell>
                <Table.Cell />
              </Table.Row>
            );
          });

          _.forEach(addressInfos, (addressdetails, addIndex) => {
            asstRows.push(
              <Table.Row
                key={`address_row_${asstIndex}_${addIndex}`}
                className={addIndex % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3} className="text-bold">
                  Address:
                </Table.Cell>
                <Table.Cell width={7}>
                  <Address
                    addressNode={addressdetails.address[0]}
                    noBreakIconsAndText
                    {...this.props}
                  />
                </Table.Cell>

                <Table.Cell width={6}>
                  <span className="text-bold"> Dates of occupancy: </span>{" "}
                  {_.get(addressdetails, "dateFirstSeen[0].year[0]._")} -
                  {_.get(addressdetails, "dateLastSeen[0].year[0]._")}
                  {_.get(addressdetails, "shared[0]._", "") === "true" ? (
                    <b> Shared Address</b>
                  ) : (
                    ""
                  )}
                </Table.Cell>
              </Table.Row>
            );

            const phoneInfo = _.get(addressdetails, "phones[0].phone[0]");
            if (phoneInfo !== undefined) {
              const contact = _.get(phoneInfo, "listingName[0]._", "");
              const tokens = contact.split(" ");
              asstRows.push(
                <Table.Row
                  width={3}
                  key={`contact_row_${asstIndex}_${addIndex}`}
                  className={addIndex % 2 === 1 ? "table-row-odd-child" : ""}
                >
                  <Table.Cell className="text-bold">Contact: </Table.Cell>
                  <Table.Cell width={7}>
                    {getPersonName(
                      tokens && tokens.length > 1 ? tokens[1] : "",
                      "",
                      tokens && tokens.length > 0 ? tokens[0] : "",
                      props
                    )}
                  </Table.Cell>
                  <Table.Cell width={6}>
                    <span className="text-bold"> Phones: </span>{" "}
                    {getPhone(
                      _.get(addressdetails, "phones[0].phone[0].phone10[0]._"),
                      props
                    )}
                  </Table.Cell>
                </Table.Row>
              );
            }

            const nameInfos = _.get(addressdetails, "residents[0].identity");
            _.forEach(nameInfos, (nameInfo, index) => {
              const age = _.get(nameInfo, "age[0]._", "");
              const dodYear = _.get(nameInfo, "DOD[0].year[0]._", "");
              asstRows.push(
                <Table.Row
                  key={`phone_row_${asstIndex}_${addIndex}_${index}`}
                  className={addIndex % 2 === 1 ? "table-row-odd-child" : ""}
                >
                  <Table.Cell width={3} />
                  <Table.Cell width={7}>
                    <span className="text-bold"> Name: </span>{" "}
                    {getPersonName(
                      _.get(nameInfo, "name[0].first[0]._", ""),
                      _.get(nameInfo, "name[0].middle[0]._", ""),
                      _.get(nameInfo, "name[0].last[0]._", ""),
                      props
                    )}
                    {age !== "" ? ` Age: ${age}` : ""}
                    {dodYear !== "" ? ` DOD: ${dodYear}` : ""}
                  </Table.Cell>
                  <Table.Cell />
                </Table.Row>
              );
            });
          });
        }

        rows.push(
          <Table.Row key={`associate_row_${asstIndex}`}>
            <Table.Cell colSpan={2}>
              <SimpleAccordionContent
                {...this.props}
                name={header}
                rows={asstRows}
              />
            </Table.Cell>
          </Table.Row>
        );
        // rows.push(
        //   <Table.Row key={`associate_row_${asstIndex}`}>
        //     <Table.Cell>
        //       <Table key={`associate_details_table_${asstIndex}`}>
        //         <Table.Body>{asstRows}</Table.Body>
        //       </Table>
        //     </Table.Cell>
        //   </Table.Row>
        // );
      });
      recCount = rows.length;
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={this.props.sectionTitle}
        rows={this.state.rows}
      />
    );
  }
}

export default Associates;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/Associates.js